import React from "react";
import CardItem from "./Carditem";
import { connect } from "react-redux";
import { getStripeListAllCardsLoader } from "store/selector/sp.selector";
import Loader from "components/common/Loader/Loader";
import { getUser } from "store/selector/auth.selector";
import { CreditCardIcon } from "@heroicons/react/outline";

const CardList = (props) => {
  const { listCardLoader, cards = [], currentUser } = props;

  if (listCardLoader) {
    return (
      <div className="flex justify-center py-12">
        <Loader cssClass="text-indigo-600" isSmallView={true} />
      </div>
    );
  }

  if (!cards.length) {
    return (
      <div className="rounded-lg border border-indigo-100 border-dashed bg-white/60 px-6 py-12 text-center">
        <CreditCardIcon className="mx-auto h-12 w-12 text-slate-400" aria-hidden="true" />
        <p className="mt-2 text-sm font-medium text-slate-700">No payment methods yet</p>
        <p className="mt-1 text-sm text-slate-500">Add a card to pay for your subscription.</p>
      </div>
    );
  }

  return (
    <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 min-w-0">
      {cards.map((card, index) => (
        <div key={card.id || index} className="min-w-0">
          <CardItem
            isDefaultCard={currentUser?.is_default_card === card.id}
            card={card}
          />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => {
  const listCardLoader = getStripeListAllCardsLoader(state);
  const currentUser = getUser(state);

  return {
    listCardLoader,
    currentUser,
  };
};

export default connect(mapStateToProps, null)(CardList);
